import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { StyledSelect } from '../Profile.styles';
import { Select } from 'antd';

const { Option } = Select;

const COMPANY_TYPES = [
  'Single Family Office',
  'Multi Family Office',
  'RIA / Financial Advisor',
  'Tax Advisors / CPA Firms',
  'Wealth Manager',
  'VC/PE Back Offices',
  'Private Bank / Wealth Management Desks',
];

const ADD_NEW_PREFIX = 'Add "';
const ADD_NEW_SUFFIX = '"';

export const CompanyTypeSelect = observer(({ value, onChange }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const handleSearch = (searchText) => {
    setSearchTerm(searchText);
  };

  const handleChange = (selectedValue) => {
    if (typeof selectedValue === 'string' && selectedValue.startsWith(ADD_NEW_PREFIX)) {
      const actualValueToAdd = selectedValue.substring(ADD_NEW_PREFIX.length, selectedValue.length - ADD_NEW_SUFFIX.length);
      onChange(actualValueToAdd);
    } else {
      onChange(selectedValue);
    }
    setSearchTerm(''); 
    setIsOpen(false); 
  };

  let filteredOptions = COMPANY_TYPES;
  if (searchTerm) {
    filteredOptions = COMPANY_TYPES.filter(option => 
      option.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  const exactMatchFound = COMPANY_TYPES.some(option => option.toLowerCase() === searchTerm.toLowerCase());
  const showAddNewOption = searchTerm && !exactMatchFound;

  const displayedOptions = [...filteredOptions];
  if (showAddNewOption) {
    displayedOptions.push(`${ADD_NEW_PREFIX}${searchTerm}${ADD_NEW_SUFFIX}`);
  }
  
  if (value && !COMPANY_TYPES.includes(value) && !displayedOptions.some(opt => opt === value || opt === `${ADD_NEW_PREFIX}${value}${ADD_NEW_SUFFIX}`)) {
    displayedOptions.unshift(value); 
  }

  return (
    <StyledSelect
      showSearch
      value={value}
      placeholder="Select or type your company description"
      style={{ width: '100%', padding: '26px 11px 5px 0' }}
      onChange={handleChange}
      onSearch={handleSearch}
      filterOption={false}
      onDropdownVisibleChange={setIsOpen}
      open={isOpen}
      notFoundContent={searchTerm ? 'No predefined matches. Type to add.' : 'Type to search or add'}
    >
      {displayedOptions.map((type) => (
        <Option key={type} value={type}>
          {type}
        </Option>
      ))}
    </StyledSelect>
  );
});